import { render, staticRenderFns } from "./searchGoods.vue?vue&type=template&id=498cd40b&scoped=true"
import script from "./searchGoods.vue?vue&type=script&lang=js"
export * from "./searchGoods.vue?vue&type=script&lang=js"
import style0 from "./searchGoods.vue?vue&type=style&index=0&id=498cd40b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498cd40b",
  null
  
)

export default component.exports